export const COMPONENT_NAME = "settings-requisites-main";
